import { DEFAULT_LOCALE, SELECTED_LOCALE } from 'constants/index';
import {
    EXPORT_LANGUAGE_ID,
    LANGUAGE_CODE,
    LANGUAGE_JAPANESE_ID,
    LANGUAGE_SHORT_CODE,
} from 'constants/language';

/**
 * get Accept Language
 *
 * @param {*} selectedLanguage
 */
export function getAcceptLanguage(selectedLanguage = 0) {
    let selectedLocale = localStorage.getItem(SELECTED_LOCALE);
    let acceptLanguage =
        !selectedLocale || selectedLocale === LANGUAGE_CODE.ENGLISH
            ? LANGUAGE_SHORT_CODE[LANGUAGE_CODE.ENGLISH]
            : LANGUAGE_SHORT_CODE[LANGUAGE_CODE.JAPANESE];
    if (selectedLanguage !== 0) {
        // neu man hinh co select language => uu tien
        acceptLanguage =
            selectedLanguage === LANGUAGE_JAPANESE_ID
                ? LANGUAGE_SHORT_CODE[LANGUAGE_CODE.JAPANESE]
                : LANGUAGE_SHORT_CODE[LANGUAGE_CODE.ENGLISH];
    }
    return acceptLanguage;
}

/**
 *
 * @returns
 */
export function getCurrentExportLanguageId() {
    const selectedLocale = localStorage.getItem(SELECTED_LOCALE);
    let currentLocale = selectedLocale ? selectedLocale : DEFAULT_LOCALE;

    const isKeyExist = currentLocale in EXPORT_LANGUAGE_ID;
    if (isKeyExist) {
        return EXPORT_LANGUAGE_ID[currentLocale];
    }

    return EXPORT_LANGUAGE_ID[LANGUAGE_CODE.JAPANESE];
}
